/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RelinkInstrumentLinkRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/RelinkInstrumentLink.pb'
import {RelinkInstrumentLinkResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/RelinkInstrumentLink.pb'


export const relinkInstrumentLink = (request:RelinkInstrumentLinkRequest, options?: CashRequestOptions) => post<RelinkInstrumentLinkRequest, RelinkInstrumentLinkResponse>("/2.0/cash/relink-instrument-link", request, {...options, rejectOnError: true })